import React from "react";
import { getAuctions } from "../../../models/auctions";
import { getAllCategories } from "../../../models/categories";
import { getAllGroups } from "../../../models/groups";
import DataTable from "react-data-table-component";
import i18n from "../../../i18n";
import { Modal } from "react-bootstrap";
import { MzadLoader } from "../../helpers/mzadLoader";
import { getAllOrganization } from "../../../models/organization";
//import AuctionTable from "./helper/auction_table";
import { apiUrl } from "../../../constants/global";
import ListAucsTable from "./list_aucs";

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
export class DashboardApproval extends React.Component {
  constructor() {
    super();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    this.state = {
      op_type: "approve",
      group_total: 0,
      is_loading: false,
      is_group_loading: false,
      auctions: [],
      pm_entries: [],
      open_popup: false,
      categories: [],
      clients: [],
      groups: [],
      selected_group: {},
      totalRows: 0,
      totalGroupRows: 0,
      currentPage: 1,
      approve: {
        approved_date: formatDate(today),
        invoice: "MZD",
      },
      reauction: {},
      counts: {
        pending: 0,
        approved: 0,
        rejected: 0,
        completed: 0,
        total: 0,
      },
      input: {
        section: "main",
        page: 1,
        limit: 500,
        //fdate: formatDate(startDate),
        //tdate: formatDate(endDate),
        search_type: "pending",
      },
      rem_amount: "",
      service_inv_link: "",
      remarks_popup: false,
      remarks: {
        amount: "",
        remark: "",
      },
      customStyles: {
        headCells: {
          style: {
            fontWeight: "bold",
            backgroundColor: "#e4f7ff",
            color: "#000000",
          },
        },
      },
      selected_id: null,
      selectedRows: [],
      columns: [
        {
          id: 1,
          name: i18n.t("sl_no"),
          sortable: true,
          wrap: true,
          width: "70px",
          cell: (row, i) => i + 1,
        },
        {
          id: 2,
          name: "ID",
          sortable: true,
          wrap: true,
          width: "70px",
          cell: (row) => row.id,
        },
        {
          id: 4,
          name: i18n.t("group_name"),
          cell: (row) => row.group_name,
        },
        {
          id: 5,
          name: i18n.t("client"),
          cell: (row) =>
            row.organization_info
              ? row.organization_info.organization_name
              : "",
          wrap: true,
        },
        {
          id: 6,
          name: i18n.t("total_auctions"),
          cell: (row) => {
            return (
              <button
                className="btn btn-outline-info btn-sm"
                style={{
                  textWrap: "nowrap",
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.setState({ is_individual: true });
                  this.openApprove(row);
                }}
              >
                {row.total_auctons}
              </button>
            );
          },
          wrap: true,
        },
        {
          id: 6,
          name: i18n.t("total_bidders"),
          cell: (row) => row.total_enrolled,
          wrap: true,
        },
        {
          id: 7,
          name: i18n.t("start_date"),
          cell: (row) => row.start_date,
          wrap: true,
        },
        {
          id: 8,
          name: i18n.t("end_date"),
          cell: (row) => row.end_date,
          wrap: true,
        },
        {
          id: 8,
          name: i18n.t("total_amount"),
          cell: (row) => row.total_amount.toFixed(3),
          wrap: true,
        },
        {
          id: 13,
          name: i18n.t("action"),
          wrap: false,
          width: "200px",
          cell: (row) => {
            let { search_type } = this.state.input;

            return (
              <div className="d-flex gap-1 mx-1 mt-1">
                {row.total_auctons > 0 && search_type === "completed" && (
                  <a
                    className="btn btn-outline-danger btn-sm text-danger"
                    style={{
                      textWrap: "nowrap",
                      cursor: "pointer",
                    }}
                    href={`${apiUrl}auction_approval/invoice?group=${row.id}`}
                    target="_new"
                  >
                    {i18n.t("invoice")}
                  </a>
                )}
              </div>
            );
          },
        },
      ],
      bidder_loader: false,
      file_approved_doc: null,
      file_reauction_doc: null,
      winners: [],
      winners_loading: false,
      winners_meta: {},
      fileInputs: [{ id: 1, file: null }],
      is_individual: true,
      auc_page: 1,
      auc_limit: 5,
    };
    this.loadAllAuctions = this.loadAllAuctions.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    console.log("params", params);
    let { input } = this.state;
    let { search_type } = this.props;
    input.search_type = search_type;
    this.setState({ search_type });
    this.loadAllCategories();
    //this.loadAllOrganisation();
    this.loadAllGroups();
    //this.loadAllAuctions(qstring);
  }

  handlePageChange = (page) => {
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    let { input } = this.state;
    input["page"] = page;
    this.setState({ currentPage: page });
    this.setState({ input: input });
    this.setState({ query: params });
    let qstring = new URLSearchParams(input).toString();
    this.loadAllGroups(qstring);
  };

  async loadAllCategories() {
    const response = await getAllCategories();
    let categories = response.data;
    this.setState({ categories });
  }

  async loadAllOrganisation() {
    let { input } = this.state;
    let q = "client_type=auc_apprv_not_approved";
    if (input.search_type) {
      q += `&search_type=${input.search_type}`;
    }
    const response = await getAllOrganization(q);
    let clients = response.data;
    this.setState({ clients });
  }

  async loadAllGroups() {
    this.setState({ is_group_loading: true });
    let { input } = this.state;
    let q = `is_client=1&page=${input.page}&limit=${input.limit}&group_type=auc_apprv_not_approved&`;
    if (input.client) {
      q += `organization=${input.client}&`;
    }
    if (input.fdate) {
      q += `fdate=${input.fdate}&`;
    }
    if (input.tdate) {
      q += `tdate=${input.tdate}&`;
    }
    if (input.search_type) {
      q += `search_type=${input.search_type}`;
    }
    const response = await getAllGroups(q);
    let groups = response.data;
    let meta = response.meta;
    this.setState({ totalGroupRows: meta.total });
    this.setState({ groups });
    if (response.success) {
      let meta = response.meta;
      this.setState({ totalRows: meta.total, counts: meta.counts });
      this.setState({ is_group_loading: false });
      if (!input.client) {
        const orgs = groups
          .map((item) => item?.organization_info)
          .filter(
            (org, index, self) =>
              index === self.findIndex((t) => t?.id === org?.id)
          );
        this.setState({ clients: orgs });
      }
    }
  }

  async loadAllAuctions(params, isFundPopup = false) {
    this.setState({ is_loading_aucs: true, auctions: [] });
    const response = await getAuctions("?is_client=1&" + params);
    if (response) {
      let auctions = response.data;
      let meta = response.meta;
      this.setState({
        auctions: auctions,
        is_loading_aucs: false,
        group_info: meta?.group || {},
      });
      this.setState({
        group_total: meta.totalAmount,
        pm_entries: meta.pm_entries,
      });
    }
  }

  openApprove(group, is_group = false) {
    let { approve, input } = this.state;
    approve.approve_status = "A";
    approve.client_name = group?.organization_info?.organization_name;
    this.setState({
      open_approve_popup: true,
      approve,
      selected_id: group.id,
      selectedRows: [],
      selected_group: group,
    });
    this.loadAllAuctions(`group=${group.id}&group_type=${input.search_type}`);
  }

  render() {
    let {
      //clients,
      groups,
      auctions,
      //pm_entries,
      //counts,
      //selectedRows,
      selected_group,
      group_total,
      input,
      //show_wallet_popup,
    } = this.state;
    let export_params = new URLSearchParams(input).toString();

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="mb-0 ">
              {/* {!this.state.is_loading && ( */}
              <div className="card-body">
                {this.state.is_loading && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "rgba(255, 255, 255, 0.7)",
                      zIndex: "99",
                    }}
                  >
                    <MzadLoader
                      animation="grow"
                      size="md"
                      loading={this.state.is_loading}
                      style={{ position: "relative" }}
                    />
                  </div>
                )}
                <div className="table-responsive ">
                  <>
                    <div className="table-wrapper">
                      <MzadLoader
                        animation="grow"
                        size="md"
                        loading={this.state.is_group_loading}
                        style={{ position: "relative" }}
                      />
                      {groups.length > 0 && (
                        <div className="d-flex gap-1 justify-content-end">
                          <div className="d-flex gap-1 justify-content-end mb-1 mx-1 mt-1">
                            <a
                              className="text-success"
                              href={`${apiUrl}auction_approval/export/excel?${export_params}`}
                              target="_new"
                            >
                              <i className="fa fa-file-excel-o fa-2x" />
                            </a>
                            <a
                              className="text-danger"
                              href={`${apiUrl}auction_approval/export/pdf?${export_params}`}
                              target="_new"
                            >
                              <i className="fa fa-file-pdf-o fa-2x" />
                            </a>
                          </div>
                        </div>
                      )}
                      <DataTable
                        responsive={true}
                        title=""
                        fixedHeader
                        columns={this.state.columns}
                        data={groups}
                        customStyles={this.state.customStyles}
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={this.state.totalGroupRows}
                        paginationPerPage={this.state.input.limit}
                        paginationDefaultPage={this.state.currentPage}
                        paginationRowsPerPageOptions={[15, 25, 50, 100]}
                        paginationComponentOptions={{
                          rowsPerPageText: "Groups per page:",
                          rangeSeparatorText: i18n.t("out"),
                        }}
                        onChangePage={this.handlePageChange}
                        onChangeRowsPerPage={(size) => {
                          this.setState({ rows_per_page: 15 });
                          let { input } = this.state;
                          input.limit = size;
                          this.setState({ input });
                          this.handlePageChange(1);
                        }}
                      />
                    </div>
                  </>
                </div>
              </div>
              {!this.state.is_loading && auctions.length === 0 && (
                <div className="m-3 text-center p-3 text-red">
                  {i18n.t("no_auctions_found")}
                </div>
              )}
            </div>
          </div>
        </div>

        <Modal
          show={this.state.open_approve_popup}
          onHide={() => this.setState({ open_approve_popup: false })}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="example-modal-sizes-title-lg"
              style={{ width: "95%" }}
            >
              <div className="d-flex justify-content-between">
                <div style={{ fontSize: "1rem" }}>
                  {selected_group?.organization_info?.organization_name} (
                  {!this.state.is_loading_aucs && (
                    <>
                      {i18n.t("total_auctions")}: {auctions.length}
                    </>
                  )}
                  )
                </div>
                {!this.state.is_loading_aucs && (
                  <div className="px-4" style={{ fontSize: "1rem" }}>
                    {i18n.t("total_amount")} {group_total.toFixed(2)}
                  </div>
                )}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader loading={this.state.is_loading_aucs} />
            {!this.state.is_loading_aucs && auctions.length > 0 && (
              <ListAucsTable
                auctions={auctions}
                group={selected_group}
                group_info={this.state.group_info}
                type={this.state.input.search_type}
              />
            )}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
